import React, { useEffect } from "react";
import { Close, MenuOpen } from "@mui/icons-material";
import NullCheck from "../../components/NullCheck";
import { useSelector } from "react-redux";
import { useState } from "react";

import MYBEE_ENERGY_LOGO from "../../assets/PluginsLogo/MYBEE_ENERGY_LOGO.svg";
import MYBEE_SERVICE_LOGO from "../../assets/PluginsLogo/MYBEE_SERVICE_LOGO.svg";
import MYBEE_METER_LOGO from "../../assets/PluginsLogo/MYBEE_METER_LOGO.svg";
import MYBEE_SYSTEM_LOGO from "../../assets/PluginsLogo/MYBEE_SYSTEM_LOGO.svg";

import MYBEE_LOGO from "../../assets/MYBEE_LOGO.svg";
import { PLUGIN_NAME, PLUGIN_PROD_LIST } from "config/const";
import PluginSelect from "./PluginSelect";
import BizSelect from "./BizSelect";
import {
  AppBar,
  Box,
  CssBaseline,
  IconButton,
  Stack,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Profile from "layout/profile";

const Header = ({ setOpenMenu, openMenu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useSelector((state) => state.userSettings?.user);
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);
  const biz = useSelector((state) => state?.biz?.data);
  const [logo, setLogo] = useState(MYBEE_LOGO);
  const [pluginLogos, setPluginLogos] = useState([]);
  const [bizList, setBizList] = useState([]);

  useEffect(() => {
    let newBizList = []
    let newPluginsList = []

    user?.business?.map(b => {
      b?.plugins?.forEach((pl) => {
        if (pl === selectedPlugin && biz?.id !== b?.id) {
          newBizList.push(b)
        }

        if (pl !== selectedPlugin && !newPluginsList.some(p => p?.sysName === pl)) {
          const findPl = PLUGIN_PROD_LIST.find(i => i?.sysName === pl)
          if (findPl) {
            newPluginsList?.push(findPl)
          }
        }

      })
    }
    )

    if (selectedPlugin === PLUGIN_NAME.MICRO_CONTROLLERS)
      setLogo(MYBEE_ENERGY_LOGO);
    else if (selectedPlugin === PLUGIN_NAME.SERVICES_CALL)
      setLogo(MYBEE_SERVICE_LOGO);
    else if (selectedPlugin === PLUGIN_NAME.METER_READ)
      setLogo(MYBEE_METER_LOGO);
    else if (selectedPlugin === PLUGIN_NAME.SYSTEM)
      setLogo(MYBEE_SYSTEM_LOGO);
    else
      setLogo(MYBEE_LOGO);

    setBizList(newBizList)
    setPluginLogos(newPluginsList)
  }, [user, selectedPlugin]);

  return (
    <Box>
      {/* <Box component="header" dir="rtl"> */}
      <CssBaseline />
      <AppBar
        position="fixed"
        // dir="rtl"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          height: isMobile ? "3.5rem" : "4rem",
          bgcolor: "bg.main",
          boxShadow: 0,
          borderBottom: 1,
          borderColor: "bg.borderBottom",
        }}
      >
        <Toolbar sx={{ px: 0.5 }}>
          <Stack width='100%'>
            <Stack
              width="100%"
              // sx={{ direction: 'ltr' }}
              direction={isMobile ? "row" : "row-reverse"}
              alignItems="center"
              justifyContent="space-between"
            >

              <NullCheck valueForCheck={isMobile}>
                <Stack direction='row' >
                  <IconButton onClick={() => setOpenMenu((open) => !open)}>
                    {openMenu
                      ? <Close color="secondary.main" />
                      : <MenuOpen color="secondary.main" />
                    }
                  </IconButton>

                  <Profile user={user} />

                  <NullCheck valueForCheck={user?.business?.length > 0}>
                    <BizSelect
                      bizList={bizList}
                      isMobile={isMobile}
                    />
                  </NullCheck>
                </Stack>
              </NullCheck>



              <NullCheck nullToDiv valueForCheck={!isMobile}>
                <Stack direction='row' spacing={1} alignItems="center">

                  <NullCheck valueForCheck={user?.business?.length > 0}>
                    <BizSelect
                      bizList={bizList}
                      isMobile={isMobile}
                    />
                  </NullCheck>

                  <Profile user={user} />

                </Stack>
              </NullCheck>

              <PluginSelect
                logo={logo}
                pluginLogos={pluginLogos}
                isMobile={isMobile}
                biz={biz}
                user={user}
              />

            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    </Box >
  );
};
export default Header;
